export default __webpack_public_path__ + "static/media/ngmi.aaba3090.webp";